
import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';  // Import Footer component
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";
const Add_DressType = () => {
  const [newUser, setNewUser] = useState({
    USER_ID: '',
    USER_NAME: '',
  });
  const [formError, setFormError] = useState(null);
  const navigate = useNavigate(); // Use navigate hook
  const [user, setUser] = useState(null);  // To store the user data (isAdmin or similar)
  const [error, setError] = useState(null); // To store error message if any
  const [loading, setLoading] = useState(true); // To manage loading state
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value,
    });
  };



  // Fetch user profile using useEffect
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    console.log(token); // for debugging
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); // Assuming the response contains the user profile info
      } catch (error) {
        setError(error.message); // Handle errors
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetch completes
      }
    };

    fetchProfile();
  }, []);
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple form validation
    if (!newUser.dress_type) {
      setFormError('field are required.');
      return;
    }
    if (!newUser.gender) {
      setFormError('field are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('dress_type', newUser.dress_type);
      formData.append('gender', newUser.gender);


      const response = await fetch(`${BASE_URL}add_dresstype`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.status) {
        throw new Error('Failed to add user');
      }

      // Redirect to the Manage User page after successful submission
      navigate('/manage_dresstype'); // You can modify this route if needed

    } catch (err) {
      setFormError(err.message);
    }
  };
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const handleCancel = () => {
    navigate('/manage_dresstype');
  }
  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container">
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  {/* Add User Card */}
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Add New Dress Type</h2>
                    </div>
                    <div className="card-body">
                      {/* Add User Form */}
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}



                        <div className="form-group">
                          <label htmlFor="dress_type">Dress Type</label>
                          <input
                            type="text"
                            id="dress_type"
                            name="dress_type"
                            className="form-control"
                            value={newUser.dress_type}
                            onChange={handleInputChange} required
                          />
                        </div>
                           <div className="form-group">
                          <label htmlFor="dress_type">Gender</label>
                          <select
    name="gender"
    id="gender"
    className="form-control"
    value={newUser.gender} // ✅ bind to state
    onChange={handleInputChange} // ✅ handle change
    required
  >
    <option value="">Select Gender</option>
    <option value="Male">Male</option>
    <option value="Female">Female</option>
  </select>
                          
                        </div>

                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer /> {/* Footer will stick to the bottom */}
      </div>
    </div>
  );
};

export default Add_DressType;
